import { render, staticRenderFns } from "./PV.vue?vue&type=template&id=71a3d36c&scoped=true"
import script from "./PV.vue?vue&type=script&lang=js"
export * from "./PV.vue?vue&type=script&lang=js"
import style0 from "./PV.vue?vue&type=style&index=0&id=71a3d36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a3d36c",
  null
  
)

export default component.exports